module.exports = __webpack_public_path__ + "img/IconTransferBranco.bb0b0f79.png";